// extracted by mini-css-extract-plugin
export default {"section":"LatestOffers_section__sZkJ+","swiperWrap":"LatestOffers_swiperWrap__pn1es","fadeNext":"LatestOffers_fadeNext__W+DRn","swiper":"LatestOffers_swiper__QCMmE"};